import type { SearchDomain, SearchSort } from '../constants';

/**
 * TanStack Query keys for the global-search results screen. Mirrors
 * `features/orders/api/queryKeys.ts` — one hierarchical factory so the
 * header search, the results screen and any invalidation agree on the
 * same tree.
 */
export const globalSearchKeys = {
  all: ['globalSearch'] as const,
  /** The header dropdown's capped, both-domain probe for a query. */
  dropdown: (query: string) => [...globalSearchKeys.all, 'dropdown', query] as const,
  counts: (query: string) => [...globalSearchKeys.all, 'count', query] as const,
  /** Per-domain total for the tab badges. */
  count: (domain: SearchDomain, query: string) =>
    [...globalSearchKeys.counts(query), domain] as const,
  pages: () => [...globalSearchKeys.all, 'page'] as const,
  /** One page of the active tab's hits. The point-in-time cursor is NOT
   *  part of the key — it is a server-side snapshot handle threaded
   *  between fetches, not an input that changes what the page means. */
  page: (
    domain: SearchDomain,
    query: string,
    page: number,
    pageSize: number,
    sort: SearchSort,
  ) =>
    [
      ...globalSearchKeys.pages(),
      domain,
      query,
      page,
      pageSize,
      sort.attribute,
      sort.order,
    ] as const,
};
